.reports__list {
  list-style-type: disclosure-closed;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reports__spending-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.reports__spending-link {
  text-decoration: underline;
}
